import { FullScreenLoader } from '@/common/ui/FullScreenLoader'
import EtfCard from './EtfCard'
import { H3 } from '@/common/ui'
import { TradingBlankState } from '@/common/assets/svg/tradingBlankState'
import { FIND_STOCKS_COPY } from '@/locales/en'
import Pagination from '@/common/ui/Pagination'

type Props = {
    filteredEtfs: any[] | undefined
    isLoading: boolean
    dataSource: string
    etfsKey: string
    positiveFilterCount: number
    pagination?: {
        currentPage: number
        setPage: (p: number) => void
        totalPages?: number
    }
}

export function EtfsGrid({ filteredEtfs, isLoading, dataSource, etfsKey, positiveFilterCount, pagination }: Props) {
    if (isLoading && dataSource === etfsKey) return <FullScreenLoader />

    if (filteredEtfs?.length) {
        return (
            <div className="px-3 md:px-6">
                <div className="text-black text-sm font-semibold font-['Inter'] leading-tight pt-6">
                    {FIND_STOCKS_COPY.showing.replace('{count}', filteredEtfs?.length.toString() ?? '0')}
                </div>
                <div className="grid mt-5 grid-wrap grid-cols-1 gap-5">
                    {filteredEtfs.map((etf: any) => {
                        const price =
                            etf.securityDetails?.priceInfo?.buyPrice ?? etf.securityDetails?.priceInfo?.closingPrice
                        return (
                            <EtfCard
                                loading={isLoading}
                                securityCode={etf.securityDetails.securityCode}
                                securityName={
                                    etf.securityDetails.companyName ??
                                    etf.securityName ??
                                    etf.securityDetails.securityName
                                }
                                price={price}
                                description={etf.securityProfile?.about?.description}
                                changeInPriceYTD={etf.changeInPriceYTD}
                                positiveThemes={etf.ethicalTags?.filter((tag: any) => tag.isTagPositive) ?? []}
                                avoidedThemes={etf.ethicalTags?.filter((tag: any) => !tag.isTagPositive) ?? []}
                            />
                        )
                    })}
                </div>
                <div className="mt-6 flex justify-center">
                    <Pagination
                        current={pagination?.currentPage ?? 1}
                        totalPages={pagination?.totalPages}
                        onChange={(p) => pagination?.setPage(p)}
                    />
                </div>
            </div>
        )
    }

    if (!positiveFilterCount) {
        return (
            <div className="text-foreground text-center flex flex-col gap-12 py-12 items-center">
                <TradingBlankState />
                <div className="max-w-sm flex flex-col gap-2">
                    <H3>{FIND_STOCKS_COPY.noPositiveFilters.title}</H3>
                    <p>{FIND_STOCKS_COPY.noPositiveFilters.description}</p>
                </div>
            </div>
        )
    }

    return (
        <div className="text-foreground text-center flex flex-col gap-2 py-6">
            <H3>{FIND_STOCKS_COPY.noResults.title}</H3>
            <p>{FIND_STOCKS_COPY.noResults.description}</p>
        </div>
    )
}

export default EtfsGrid
